import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { ISiteAdminProfile } from './GetSiteAdminProfilesRequest';

export interface IGetAdminProfileForUserParams {
  userLuid: string;
}

export interface IGetAdminProfileForUserResult {
  adminProfile: ISiteAdminProfile | null;
}

export class GetAdminProfileForUserRequest extends Request<IGetAdminProfileForUserParams, IGetAdminProfileForUserResult> {
  constructor(params: IGetAdminProfileForUserParams) {
    super('getAdminProfileForUser', params);
  }
}
